module.exports = function() {
  return new Worker(__webpack_public_path__ + "js/worker.b4893637d468a88a7b8e.js");
};